import { isDrawingsRelayOperation } from 'smx-drawings';

export const graphqlRouterMiddleware = async (args: any, next: any) => {
    const { context } = args;

    if (isDrawingsRelayOperation(args)) {
        context.url = process.env.REACT_APP_DRAWINGS_API_URL;
    }

    return next(args);
};
